<template>
    <v-container fluid>
        <template v-if="isAuthorized">
            <v-row no-gutters class="pb-2 mr-2">
                <!-- <v-col cols=2>
                    <v-btn

                        color="secondary"
                        @click="newBudgetForm"
                        elevation="0"
                        block
                        height="40px"
                        class="rounded-lg gradient"
                    >Ajouter</v-btn>
                </v-col> -->
                <v-col cols="2" class="pb-2">
                    <v-btn-primary @click="newBudgetProcess" block id="Senario"
                        >Ajouter</v-btn-primary
                    >
                </v-col>
                <!-- <v-col cols=2 class="pb-2 pl-2">
                    <v-btn

                        color="secondary"
                        @click="openBudgetModeSelector"
                        elevation="0"
                        block
                        height="40px"
                        class="rounded-lg gradient"
                    >Hybride</v-btn>
                </v-col> -->
                <!-- <v-col cols=2 v-if="currentUser.profile.configuration.budget.import" class="pl-2">
                    <v-btn

                        color="secondary"
                        @click="activeBudget = true"
                        elevation="0"
                        block
                        height="40px"
                        class="rounded-lg gradient"
                    >Importer</v-btn>
                </v-col> -->
                <v-col cols="2" class="pl-2">
                    <v-menu>
                        <template v-slot:activator="{ props }">
                            <v-text-field
                                outlined
                                :hide-details="true"
                                v-bind="props"
                                readonly
                                :append-inner-icon="'arrow_drop_down'"
                                :model-value="
                                    selected != -1
                                        ? scenariosSelection[selected].name
                                        : 'Pas de scénario'
                                "
                                density="compact"
                            />
                        </template>
                        <v-list v-if="scenariosSelection && scenariosSelection.length">
                            <v-list-item
                                v-for="(item, index) in scenariosSelection"
                                :key="index"
                                @click="
                                    id = item.id;
                                    selected = index;
                                "
                            >
                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
                <v-col cols="2" class="pl-2" id="Year">
                    <v-select
                        v-if="id"
                        v-model="selectedPeriod"
                        :items="periodsList"
                        item-value="id"
                        outlined
                        single-line
                        hide-details
                        label="Exercice"
                        density="compact"
                        :item-title="(item) => item.name"
                    >
                    </v-select>
                </v-col>
                <v-col v-if="!$vuetify.display.mobile" class="d-flex align-center">
                    <TutorialButtonDialog :starterComponents="'Budgets;'"> </TutorialButtonDialog>
                </v-col>
                <v-col class="d-flex justify-end align-center" id="Help">
                    <v-tooltip v-if="isFormEditable" location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-icon icon="$oss-edit" v-bind="props" @click="editBudgetForm()">
                            </v-btn-icon>
                        </template>
                        <span>Editer</span>
                    </v-tooltip>
                    <v-tooltip v-if="enableDuplicate" location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$oss-duplicate"
                                v-bind="props"
                                @click="copyBudgetForm()"
                            >
                            </v-btn-icon>
                        </template>
                        <span>Dupliquer</span>
                    </v-tooltip>
                    <v-tooltip v-if="selected != -1" location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-trash v-bind="props" @click="deleteBudgetDialog = true">
                            </v-btn-trash>
                        </template>
                        <span>Supprimer</span>
                    </v-tooltip>
                    <v-tooltip v-if="id" location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$oss-download"
                                v-bind="props"
                                @click="downloadExcel"
                                :disabled="downloadDisabled"
                            >
                            </v-btn-icon>
                        </template>
                        <span>Télécharger</span>
                    </v-tooltip>
                </v-col>
                <!-- <v-flex class="d-flex justify-end">
                    <v-btn
                        outlined
                        style="padding-right: 10px; margin-top: 22px;"
                        color="secondary"
                        class="btn"
                        @click="downloadPDF"
                        v-if="id"
                    >
                        <v-icon style="margin-right: 3px">
                            file_download
                        </v-icon>
                        PDF
                    </v-btn>
                </v-flex> -->
            </v-row>
            <v-row no-gutters class="pb-2 mr-2">
                <v-col>
                    <BudgetDiagram
                        v-if="id"
                        :budgetId="id"
                        :companyId="selectedCompany.id"
                        :startDate="scenariosSelection[selected].date"
                        :selectedPeriod="selectedPeriod"
                        :refreshData="refreshData"
                        @get-periods-list="onPeriodsListChanged"
                        @isDownloadable="isDownloadable"
                    />
                    <v-card v-else-if="loading" elevation="0">
                        <v-card-text style="text-align: center" class="pa-0">
                            <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                                style="margin: 24px"
                            />
                        </v-card-text>
                    </v-card>
                    <v-card
                        v-else-if="!scenariosSelection.length"
                        class="default_card large"
                        elevation="0"
                    >
                        <v-card-title style="text-align: center !important" primary-title>
                            Créer votre premier budget prévisionnel
                        </v-card-title>
                        <v-card-text style="text-align: center">
                            <v-btn
                                class="btn_card"
                                rounded
                                @click="newBudgetProcess"
                                elevation="0"
                                id="Ajouter"
                                size="small"
                                ><v-icon style="margin-right: 3px"> $assessment </v-icon>Ajoutez
                                votre premier scénario</v-btn
                            >
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <FullBudgetProcess
                v-model="showBudgetProcess"
                :budgetId="budgetToEdit"
                :budgetIdToCopy="budgetToCopy"
                @budget-created="onBudgetCreated"
                @budget-modified="onBudgetModified"
                v-if="showBudgetProcess"
            />
            <oss-dialog
                v-model="displayBudgetModeSelector"
                title="Sélectionner la méthode d'initialisation de votre budget"
                min-height="90vh"
                @valid="openSelectedBudgetMode"
                width="800px"
            >
                <v-row>
                    <v-col cols="12">
                        <div class="body-1">
                            Souhaitez-vous initialiser votre budget à partir de votre dernier
                            exercice enregistré ?
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <div class="body-1 px-2" style="text-align: justify">
                            Cette méthode permet de récupérer les comptes comptables de votre
                            exercice précédent et de sélectionner les champs que vous souhaitez
                            reporter dans votre prochain budget. Vous pourrez choisir de reporter un
                            pourcentage de ces montants si vous le souhaitez.
                        </div>
                        <div class="body-1 px-2" style="text-align: justify">
                            Cette méthode est recommandée pour réaliser un budget précis de
                            l'exercice à venir.
                        </div>
                        <div class="body-1 px-2" style="text-align: justify">
                            Attention : vous devez disposer de données pour l'exercice précédent
                            pour l'appliquer.
                        </div>
                        <div
                            class="body-1 px-2"
                            style="color: red; text-align: justify"
                            v-if="!selectedAccountingPeriod"
                        >
                            Veuillez sélectionner un exercice comptable pour appliquer cette
                            méthode.
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <div class="body-1 px-2" style="text-align: justify">
                            Si vous passez cette étape, vous commencerez avec un budget vierge.
                        </div>
                        <div class="body-1 px-2" style="text-align: justify">
                            Ce cas de figure est recommandé pour la création d'un budget de
                            démarrage à moyen ou long terme, ou si vous ne disposez pas encore de
                            données pour l'exercice précédent.
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-spacer />
                    <v-col cols="10" class="d-flex justify-center">
                        <v-select-filled
                            v-model="budgetMode"
                            :items="budgetModes"
                            item-value="id"
                            outlined
                            single-line
                            hide-details
                            label="Méthode d'initialisation"
                            density="compact"
                            :item-title="(item) => item.name"
                        />
                    </v-col>
                    <v-spacer />
                </v-row>
                <!-- <v-row v-if="budgetMode === 'NM1'">
                        <v-col cols="12">
                            <div class="body-1 px-2" style="text-align: justify">
                                Vous pouvez maintenant choisir comment regrouper vos lignes de charges de l'année précédente.
                            </div>
                            <div class="body-1 px-2" style="text-align: justify">
                                Vous pouvez les regrouper par compte comptable, ou bien par fournisseur.
                            </div>
                            <div class="body-1 px-2" style="text-align: justify">
                                Néanmoins, cette méthode de regroupement ne s'applique que pour vos charges. Vos ventes seront forcément regroupées par compte comptable.
                            </div>
                        </v-col>
                    </v-row> -->
                <!-- <v-row v-if="budgetMode === 'NM1'">
                        <v-spacer></v-spacer>
                        <v-col cols="10" class="d-flex justify-center">
                            <v-select
                                v-model="chargesGroupingMode"
                                :items="chargesGroupingModes"
                                item-text="name"
                                item-value="id"
                                outlined
                                single-line
                                dense
                                hide-details
                                class="oss-"
                                label="Méthode de regroupement">
                            </v-select>
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>    -->
            </oss-dialog>
            <!-- <oss-dialog
                v-model="showFormNM1"
                :title="'Initialisation du budget avec les comptes précédents'"
                width="800px"
                @valid="showFormNM1 = false;"
            >Test form NM1
            </oss-dialog> -->
            <BudgetFormAccountableAccount
                v-if="showFormNM1"
                v-model="showFormNM1"
                :id="selectedBfaaId"
                :chargesGroupingMode="chargesGroupingMode"
                @initialize-bff="onInitializeBff"
            />
            <oss-dialog
                v-model="deleteBudgetDialog"
                :title="'Supprimer un scénario'"
                @valid="deleteBudget"
                width="800px"
            >
                <div class="body-1">&#xca;tes-vous sur de vouloir supprimer un scénario ?</div>
            </oss-dialog>
        </template>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { User } from "../store/store";

import moment from "moment-timezone";

import SCENARIO_NAMES from "../graphql/budget/BudgetScenario.gql";
// import DELETE_BUDGET_ACCOUNTING_LINES from "../graphql/budget/DeleteBudgetAccountingLines.gql";
// import DELETE_BUDGET from "../graphql/budget/DeleteBudget.gql";
import DELETE_CLEAN_BUDGET from "../graphql/budget/DeleteCleanBudget.gql";

import BudgetDiagram from "./BudgetDiagram.vue";
import TutorialButtonDialog from "./tutorial/TutorialButtonDialog.vue";
import BudgetFormAccountableAccount from "./budgetForm/BudgetFormAccountableAccount.vue";
import FullBudgetProcess from "./budgetForm/FullBudgetProcess.vue";
import { checkAccessRights } from "../services/accessRightServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import emitter from "@/services/emitter";

@Component({
    components: {
        BudgetDiagram,
        TutorialButtonDialog,
        BudgetFormAccountableAccount,
        FullBudgetProcess,
    },
    emits: ["download-pdf"],
})
export class Budgets extends Vue {
    id: string = "";
    selected: number = -1;

    // activeBudget = false;

    showForm = false;
    showFormFull = false;
    showBudgetProcess = false;

    tabs: any;

    budgetToEdit = "";
    budgetToCopy = "";

    loading: boolean = false;

    selectedPeriod: number = 1;
    periodsList = [];
    refreshData: number = 0;

    displayBudgetModeSelector: boolean = false;
    budgetMode: string = "EMPTY";
    chargesGroupingMode: string = "AA";
    showFormNM1: boolean = false;
    selectedBfaaId: string = "";
    selectedFormBfaa: any = null;
    selectedBfaaEndDate: string = null;
    groupingMode: string = null;
    // bffToInitialize: boolean = false;

    downloadDisabled = true;
    createdSenario = false;

    manualScenariosSelection = [
        { id: "", name: "Pas de budget lié", type: "", date: moment().format() },
    ];

    chargesGroupingModes = [
        { id: "AA", name: "Regrouper les charges par compte comptable" },
        { id: "TPC", name: "Regrouper les charges par fournisseur" },
    ];

    get selectedAccountingPeriod() {
        return this.$store.state.accountingPeriod.selectedAccountingPeriod;
    }

    get budgetModes() {
        if (this.selectedAccountingPeriod) {
            return [
                { id: "NM1", name: "Initialiser avec des comptes de l'exercice précédent" },
                { id: "EMPTY", name: "Commencer directement avec un budget vierge" },
            ];
        } else {
            return [{ id: "EMPTY", name: "Commencer directement avec un budget vierge" }];
        }
    }

    set budgetModes(newValue) {
        if (newValue.length && newValue.length > 0) {
            this.budgetMode = newValue[0].id;
        }
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "budget", "read");
        return authorized;
    }

    @Apollo({
        query: SCENARIO_NAMES,
        variables() {
            return {
                companyId: this.selectedCompany.id,
            };
        },
        skip() {
            return !this.isAuthorized;
        },
        fetchPolicy: "network-only",
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading) {
                // this.scenariosSelection = data.budgets;
                const manualScenarios = [];
                const otherScenarios = [];
                for (const scenario of data.budgets) {
                    if (scenario.type === "MANUAL") {
                        manualScenarios.push(scenario);
                    } else {
                        otherScenarios.push(scenario);
                    }
                }
                if (otherScenarios.length) {
                    for (
                        let scenarioIndex = 0;
                        scenarioIndex < otherScenarios.length;
                        scenarioIndex++
                    ) {
                        if (!otherScenarios[scenarioIndex].id) {
                            otherScenarios.splice(scenarioIndex, 1);
                            scenarioIndex--;
                        }
                    }
                    if (
                        otherScenarios.length &&
                        (!this.id || !otherScenarios.find((s) => s.id === this.id))
                    ) {
                        this.id = otherScenarios[0].id;
                        this.selected = 0;
                    }
                    manualScenarios.unshift({
                        id: "",
                        name: "Pas de budget lié",
                        type: "",
                        date: moment().format(),
                    });
                    this.manualScenariosSelection = manualScenarios;
                    this.scenariosSelection = otherScenarios;
                } else if (this.id) {
                    this.id = "";
                    this.selected = -1;
                }
                this.budgetToEdit = "";
                this.budgetToCopy = "";
                console.log(this.scenariosSelection);
            }
        },
    })
    scenariosSelection: Array<any> = [];

    async onBudgetCreated(createdBudget) {
        this.scenariosSelection.push(createdBudget);
        this.selected = this.scenariosSelection.length - 1;
        this.id = createdBudget.id;
        // this.bffToInitialize = false;
    }

    async onBudgetModified(modifiedBudget) {
        // for (const scenario of this.scenariosSelection) {
        //     if (scenario.id === modifiedBudget.id) {
        //         scenario.name = modifiedBudget.name;
        //         break;
        //     }
        // }
        if (this.$apollo.queries) {
            if (this.$apollo.queries.scenarios) {
                await this.$apollo.queries.scenarios.refetch();
            }
        }
        this.id = "";
        this.id = modifiedBudget.id;
        this.refreshData++;
        // setTimeout(() => {
        //     this.id = "";
        //     this.id = modifiedBudget.id;
        // }, 100);
        // this.bffToInitialize = false;
    }

    get isFormEditable() {
        if (this.id) {
            return this.scenariosSelection.find(
                (child) =>
                    child.id === this.id &&
                    (child.type === "FORM" ||
                        child.type === "FORM_FULL" ||
                        child.type === "MANUAL"),
            );
        }
        return false;
    }

    get enableDuplicate() {
        if (this.id) {
            return this.scenariosSelection.find(
                (child) => child.id === this.id && child.type === "FORM_FULL",
            );
        }
        return false;
    }
    //
    // delete budget
    //

    deleteBudgetDialog: boolean = false;

    deleteBudgetLoading: boolean = false;

    async deleteBudget() {
        // debugger;
        this.deleteBudgetLoading = true;

        // await this.$apollo.mutate({   Besoin de delete tous les accountingsLines liées au Budget ?
        //     mutation: DELETE_BUDGET_AMOUNTS,
        //     variables: {
        //         id: this.id
        //     }
        // });

        // await this.$apollo.mutate({
        //     mutation: DELETE_BUDGET_ACCOUNTING_LINES,
        //     variables: {
        //         id: this.id
        //     }
        // });

        // await this.$apollo.mutate({
        //     mutation: ,
        //     variables: {}
        // });

        // await this.$apollo.mutate({
        //     mutation: DELETE_BUDGET,
        //     variables: {
        //         id: this.id
        //     }
        // });

        const deletionResult = await this.$apollo.mutate({
            mutation: DELETE_CLEAN_BUDGET,
            variables: {
                budgetId: this.id,
            },
        });

        const deletedId = deletionResult.data.deleteCleanBudget.id || this.id;

        const index = this.scenariosSelection.findIndex((scenario) => scenario.id === deletedId);
        if (index !== -1) {
            this.scenariosSelection.splice(index, 1);
        }
        if (this.scenariosSelection.length) {
            this.id = this.scenariosSelection[0].id;
            this.selected = 0;
        } else {
            this.id = "";
            this.selected = -1;
        }

        this.deleteBudgetLoading = false;
        this.deleteBudgetDialog = false;
    }

    editBudgetForm() {
        // debugger
        this.budgetToEdit = this.id;
        this.budgetToCopy = "";

        const budget = this.scenariosSelection.find((child) => child.id === this.id);

        this.showForm = false;
        this.showFormFull = false;
        if (budget) {
            if (budget.type === "FORM") {
                this.showForm = true;
            } else if (budget.type === "FORM_FULL" || budget.type === "MANUAL") {
                this.showBudgetProcess = true;
            }
        }
    }

    copyBudgetForm() {
        if (this.id) {
            this.budgetToEdit = "";
            this.budgetToCopy = this.id;
            this.showBudgetProcess = true; // updated
        }
    }

    // newBudgetForm() {
    //     this.budgetToEdit = "";
    //     this.budgetToCopy = "";
    //     this.showForm = true;
    // }

    newBudgetFormFull() {
        // debugger
        this.budgetToEdit = "";
        this.budgetToCopy = "";
        this.showFormFull = true;
    }

    newBudgetProcess() {
        this.budgetToEdit = "";
        this.budgetToCopy = "";
        this.showBudgetProcess = true;
    }

    downloadExcel() {
        emitter.$emit("download-excel");
    }

    downloadPDF() {
        this.$emit("download-pdf");
    }

    onPeriodsListChanged(data) {
        this.periodsList = data;
    }

    openBudgetModeSelector() {
        this.displayBudgetModeSelector = true;
    }

    openSelectedBudgetMode() {
        this.displayBudgetModeSelector = false;
        if (this.budgetMode === "NM1") {
            this.showFormNM1 = true;
        } else if (this.budgetMode === "EMPTY") {
            this.newBudgetFormFull();
        } else {
            debugger;
        }
    }

    onUpsertBfaa(bfaaId) {
        this.selectedBfaaId = bfaaId;
        this.showFormNM1 = true;
    }

    onInitializeBff(event) {
        this.selectedBfaaId = event.id; // in case a new bfaa has been created
        this.selectedFormBfaa = event.form; // amountsToReport
        this.selectedBfaaEndDate = event.end;
        this.groupingMode = event.groupingMode;
        if (!this.manualScenariosSelection.find((scenario) => scenario.id === event.id)) {
            const newManualScenario = {
                id: event.id,
                date: event.start,
                type: event.type,
                name: event.name,
            };
            this.manualScenariosSelection.push(newManualScenario);
        }
        // this.bffToInitialize = true; // true if amounts are to report from the related bfaa
        this.showFormFull = true;
    }

    isDownloadable(value_from_child) {
        this.downloadDisabled = !value_from_child;
    }

    startTuto() {
        emitter.$emit("setTutorialData", [
            {
                ref: document.getElementById("Senario"),
                title: "Crée ton sénario",
                pages: [
                    {
                        text: "Si vous n’avez pas de scénario de créé vous pouvez en ajouter ici et suiviez l’assistant de création",
                        position: "right",
                        align: "center",
                    },
                ],
            },
        ]);
    }

    startCreatedTuto() {
        emitter.$emit("setTutorialData", [
            {
                ref: document.getElementById("Menu"),
                title: "Présentation du sénario",
                pages: [
                    {
                        text: "Voici la présentation par onglet des états du prévisionnel",
                        position: "bottom",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Year"),
                title: "Choix de l'année",
                pages: [
                    {
                        text: "Vous pouvez choisir ici l’année à visualiser",
                        position: "right",
                        align: "center",
                    },
                ],
            },
            {
                ref: document.getElementById("Help"),
                title: "Duplication ou modification",
                pages: [
                    {
                        text: "Il est possible de télécharger des états, dupliquer ou modifier le prévisionnel ici ",
                        position: "left",
                        align: "center",
                    },
                ],
            },
        ]);
    }

    chooseTuto() {
        if (!this.scenariosSelection.length) {
            this.startTuto();
        } else {
            this.startCreatedTuto();
        }
    }
}

export default toNative(Budgets);
</script>
